import styled, { css } from 'styled-components';

interface ContainerProps {
  isDragActive: boolean;
  isErrored: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  span {
    color: ${({ theme }) => theme.error};
  }
`;

export const Container = styled.div<ContainerProps>`
  background: ${({ theme }) => theme.hover};
  height: 5rem;
  border-radius: 0.4rem;
  text-align: center;
  border: 2px dashed
    ${({ theme, isDragActive }) =>
      isDragActive ? theme.button.success.out : theme.cardBorder};

  ${props =>
    props.isErrored &&
    css`
      border: 2px dashed ${({ theme }) => theme.error};
    `}

  display: flex;
  align-items: center;
  justify-content: center;
`;
